import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingType, TicketsBaseComponent } from '@resident-nx/shared';
import { TicketCardWebComponent } from '../ticket-card/ticket-card.component';
import { CardWebComponent, IconWebComponent, LoaderWebComponent } from '@resident-nx/web/ui';
import { NoDataWebComponent } from '../../../atoms/no-data/no-data.component';
import { LoadingSkeletonWebComponent } from '../../../atoms/loading-skeleton/loading-skeleton.component';

@Component({
  standalone: true,
  selector: 'rs-web-tickets',
  imports: [
    TicketCardWebComponent,
    CardWebComponent,
    TranslateModule,
    IconWebComponent,
    NoDataWebComponent,
    LoadingSkeletonWebComponent,
    LoaderWebComponent,
  ],
  templateUrl: './tickets.component.html',
  styleUrl: './tickets.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketsWebComponent extends TicketsBaseComponent {
  @Input() createButtonText: string;
  @Input() hasActiveContracts: boolean;
  @Output() createTicket = new EventEmitter();
  protected readonly LoadingType = LoadingType;
}
